import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=15d648ae"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"
import style0 from "./Aside.vue?vue&type=style&index=0&id=15d648ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports